/**
 * `components.MuiModal` — `disableEnforceFocus` default (Intercom typing when overlays are open).
 * Discoverability: `MuiModal`, `Modal`, `disableEnforceFocus`.
 *
 * @see https://mui.com/material-ui/api/modal/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiModal(_theme: Theme): Pick<Components<Theme>, 'MuiModal'> {
  return {
    MuiModal: {
      defaultProps: {
        // This is because if any dialog / popover / menu is open, the user cannot type into Intercom. This has the side
        // effect of potentially losing focus for the modal, which affects accessibility. If we decide to remove this,
        // please consider all things
        disableEnforceFocus: true,
      },
    },
  };
}
